/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  work_id: z.number().nullable(),
  preparer_user_id: z.string().uuid(),
  project_type: z.string(),
  work_type: z.string(),
  work_subcategory: z.string(),
  execution_method: z.string(),
  mixing_method: z.string(),
  plan_info_1: z.string(),
  plan_info_2: z.string(),
  plan_info_3: z.string(),
  plan_info_4: z.string(),
  plan_info_5: z.string(),
  plan_info_6: z.string(),
  plan_info_7: z.string(),
  plan_info_8: z.string(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
  work_id: base.shape.work_id.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() });
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
  preparer_user_id: true,
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const ConstructionPlanBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type ConstructionPlanBase = z.infer<typeof base>;
export type ConstructionPlanBasePutPayload = z.infer<typeof put>;
export type ConstructionPlanBasePatchPayload = z.infer<typeof patch>;
export type ConstructionPlanBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type ConstructionPlanBaseCreateAttributes = z.infer<typeof create>;
export type ConstructionPlanBaseUpdateAttributes = z.infer<typeof update>;
export type ConstructionPlanBaseCacheAttributes = z.infer<typeof cache>;
export type ConstructionPlanBaseCachesAttributes = z.infer<typeof caches>;